<template>
  <v-dialog v-model="dialog" persistent width="500">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="Boolean(clientSchool)"
        v-on="on"
        @click="openDialog"
        text
        x-small
        color="primary"
      >
        <v-icon small>mdi-pencil</v-icon></v-btn
      >
      <v-btn
        v-else
        v-on="on"
        @click="openDialog"
        small
        color="primary"
        tile
        outlined
        class="ma-4"
      >
        <v-icon small>mdi-plus</v-icon> New Registration
      </v-btn>
    </template>
    <validation-observer ref="form" v-slot="{ invalid }">
      <v-card>
        <v-card-title color="primary">
          School Registration
          <v-spacer></v-spacer>
          <v-btn color="primary" icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn> </v-card-title
        ><v-card-text>
          <validation-provider rules="required" v-slot="{ errors }">
            <v-autocomplete
              v-model="form.semesterId"
              label="Semester"
              :items="semesters"
              :item-text="
                (item) => `${item.semesterCode} - ${item.semesterDescription}`
              "
              @change="autopopulateSemesterDates"
              item-value="semesterId"
              :error-messages="errors"
              :clearable="canEdit"
              :readonly="!canEdit"
            ></v-autocomplete>
          </validation-provider>
          <school-lookup
            :school="form.school"
            :isSummerSemester="isSummerSemester"
            :clientId="client.clientId"
            :validations="{ required: true }"
            :readonly="!canEdit"
            @selectSchool="selectSchool"
          ></school-lookup>
          <v-row>
            <v-col cols="12" sm="6">
              <div class="pt-4">
                <date-picker
                  :field="{ label: 'Effective Date' }"
                  :value="form.effectiveDate"
                  :validations="{ required: true }"
                  @fieldChange="form.effectiveDate = $event"
                  :readonly="!canEdit"
                >
                </date-picker></div></v-col
            ><v-col cols="12" sm="6">
              <div class="pt-4">
                <date-picker
                  :field="{ label: 'End Date' }"
                  :value="form.endDate"
                  :validations="{ required: true }"
                  @fieldChange="form.endDate = $event"
                  :readonly="!canEdit"
                >
                </date-picker></div></v-col
          ></v-row>
          <v-divider></v-divider>
          <v-checkbox
            v-model="hasSubSchool"
            label="Is Sub School"
            :readonly="!canEdit"
          ></v-checkbox>
          <div v-if="Boolean(hasSubSchool)">
            <school-lookup
              :school="form.subSchool"
              :isSummerSemester="isSummerSemester"
              :clientId="client.clientId"
              :readonly="!canEdit"
              @selectSchool="selectSubSchool"
            ></school-lookup>
            <v-row>
              <v-col cols="12" sm="6">
                <div class="pt-4">
                  <date-picker
                    :field="{ label: 'Effective Date' }"
                    :value="form.subSchoolEffectiveDate"
                    :validations="{ required: true }"
                    @fieldChange="form.subSchoolEffectiveDate = $event"
                    :readonly="!canEdit"
                  >
                  </date-picker></div></v-col
              ><v-col cols="12" sm="6">
                <div class="pt-4">
                  <date-picker
                    :field="{ label: 'End Date' }"
                    :value="form.subSchoolEndDate"
                    :validations="{ required: true }"
                    @fieldChange="form.subSchoolEndDate = $event"
                    :readonly="!canEdit"
                  >
                  </date-picker></div></v-col
            ></v-row>
          </div>
        </v-card-text>
        <v-card-actions v-if="canEdit">
          <v-spacer></v-spacer>
          <v-btn small color="primary" text @click="closeDialog">Cancel</v-btn>
          <v-btn
            small
            color="primary"
            :disabled="invalid || loading"
            @click="save"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import ClientSchool from "../../../objs/ClientSchool";
import SchoolLookup from "../../Schools/school-lookup";
export default {
  components: { SchoolLookup },
  props: ["clientSchool"],
  data() {
    return {
      form: new ClientSchool(),
      dialog: false,
      hasSubSchool: false,
      loading: false,
    };
  },
  computed: {
    canEdit() {
      return this.$store.getters["securityModule/isProgramAdmin"];
    },
    semesters() {
      return this.$store.state.optionsModule.semesters || [];
    },
    selectedSemester() {
      return this.$store.getters["optionsModule/getSemesterById"](
        this.form.semesterId
      );
    },
    isSummerSemester() {
      return this.selectedSemester?.summerSemester ?? null;
    },
    client() {
      return this.$store.state.clientModule.selectedClient;
    },
  },
  methods: {
    selectSchool(schoolId) {
      this.form.schoolId = schoolId ?? null;
    },
    selectSubSchool(schoolId) {
      this.form.subSchoolId = schoolId ?? null;
    },
    autopopulateSemesterDates() {
      if (this.form.semesterId) {
        this.form.effectiveDate = new Date(
          this.selectedSemester.semesterStartDate
        );
        this.form.endDate = new Date(this.selectedSemester.semesterEndDate);
      } else {
        this.form.effectiveDate = "";
        this.form.endDate = "";
      }
    },
    openDialog() {
      if (this.clientSchool != null) {
        this.form = { ...this.clientSchool };
        this.hasSubSchool = Boolean(this.clientSchool.subSchool);
      }
      this.form.clientId = this.client.clientId;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async save() {
      this.loading = true;
      let message;
      // update
      if (this.clientSchool) {
        message = await this.$store.dispatch(
          "clientModule/updateClientSchool",
          this.form
        );
      } else {
        // create
        message = await this.$store.dispatch(
          "clientModule/createClientSchool",
          this.form
        );
      }
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Client registration saved successfully"
        );
      }
      this.loading = false;
      this.$store.commit("uxModule/setShowSnackbar", true);
      this.closeDialog();
    },
  },
};
</script>
